import React from 'react';
import PreviewModal from '~/src/components/Modal/PreviewModal';

interface PlanChangePreviewModalProps {
  previewData: any;
  currentPlanName: string;
  newPlanName: string;
  onCancel: () => void;
  onConfirm?: () => void;
  isProcessing?: boolean;
}

export const PlanChangePreviewModal = ({
  previewData,
  currentPlanName,
  newPlanName,
  onCancel,
  onConfirm,
  isProcessing = false,
}: PlanChangePreviewModalProps) => {
  const invoiceData = previewData?.preview?.data || previewData?.data;
  const { immediate_invoice, recurring_invoice } = invoiceData || {};

  return (
    <PreviewModal
      title="Plan Upgrade Preview"
      onCancel={onCancel}
      onConfirm={onConfirm}
      isProcessing={isProcessing}
      confirmText="Confirm Upgrade"
      cancelText="Close"
      confirmDisabled={!previewData}
      beforeAfterState={{
        currentLabel: 'Current Plan',
        newLabel: 'New Plan',
        currentValue: currentPlanName,
        newValue: newPlanName,
      }}
      invoiceSection={{
        immediateInvoice: immediate_invoice,
        recurringInvoice: recurring_invoice,
      }}
      importantNotes={[
        'Plan upgrades are prorated and charged immediately',
        'New plan features will be available immediately after upgrade',
        'Your recurring billing amount will be updated accordingly',
      ]}
    />
  );
};
